export const ovProductName: string = "OptiVista<sup>23</sup> Pro Naturals";
export const ggProductName: string = "GlucoGen<sup>17</sup> Naturals";
export const ggNgProductName: string = "GG<sup>17</sup> Naturals";
